<template>
  <div :id="inputId + '-wrap'" class="requirements-wrapper">
    <div
      v-for="(marker, index) in localMarkers"
      :key="index"
      class="requirements"
      :class="{
        'applied': inputValue !== '' && marker.isValid, 
        'error': inputValue !== '' && !marker.isValid
      }"
    >
      <span>{{ marker.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "RequirementMarkers",
  props: {
    inputId: {
      type: String,
      required: true,
    },
    markers: {
      type: Array,
      required: true,
    },
    password: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      inputValue: "",
      localMarkers: [...this.markers],
    };
  },
  methods: {
    validateMarkers() {
      this.localMarkers = this.localMarkers.map((marker) => {
        let isValid = false;

        switch (marker.type) {
          case "min-length":
            isValid = this.inputValue.length >= marker.value;
            break;
          case "regex":
            const regex = new RegExp(marker.value);
            isValid = regex.test(this.inputValue);
            break;
        }
      
        return { ...marker, isValid };
      });

      const allValid = this.localMarkers.every((marker) => marker.isValid);
      this.$emit('validation-status', allValid);
    },
    handleInput(event) {
      this.inputValue = event.target.value;
      setTimeout(() => {
        this.validateMarkers();
      }, 10);
    },
  },
  watch: {
    password(newValue) {
      this.inputValue = newValue;
      this.validateMarkers();
    },
  },
  mounted() {
    const inputElement = document.getElementById(this.inputId);
    if (inputElement) {
      inputElement.addEventListener("keyup", this.handleInput);
    }
  },
  beforeUnmount() {
    const inputElement = document.getElementById(this.inputId);
    if (inputElement) {
      inputElement.removeEventListener("keyup", this.handleInput);
    }
  },
};
</script>
  
  <style scoped lang="scss">
  .requirements {
    span {
        width: 100%;
        display: block;
        text-align: left;
        margin-bottom: 10px;
        padding-left: 20px;
        background-image: url("/webpack-assets/img/site/login/icons/circle.svg");
        background-repeat: no-repeat;
        background-position: 0px center;
        color: #fff;
        font-size: 14px;
    }
    &.error {
        span{
            color: #FF6161;
            background-image: url("/webpack-assets/img/site/login/icons/cross.svg");
        }
    }

    &.applied {
        span{
            color: #46CA43;
            background-image: url("/webpack-assets/img/site/login/icons/check.svg");
        }
    }
  }
  </style>
  